import {
  GET_ORDER_ATTACHMENTS,
  GET_ORDER_ATTACHMENTS_SUCCESS,
  GET_ORDER_ATTACHMENTS_FAIL,
  GET_ORDER_ATTACHMENT_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const orderAttachment = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ORDER_ATTACHMENTS:
      return {
        ...state,
        loading: true,
      };
    case GET_ORDER_ATTACHMENTS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_ORDER_ATTACHMENT_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_ORDER_ATTACHMENTS_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default orderAttachment;
